export default __webpack_public_path__ + "static/media/image-spaceport-portrait.85523db5.jpg";